import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetcher } from '../../../lib/api-fetcher';

export function useDevices(filters?: any) {
  return useQuery({
    queryKey: ['settings', 'devices', filters],
    queryFn: async () => {
      const params = filters ? '?' + new URLSearchParams(filters as Record<string, string>).toString() : '';
      return fetcher.get<any[]>(`/staff/v1/settings/devices${params}`);
    },
  });
}

export function useRegisterDevice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: { fingerprint: string; label: string }) => {
      return fetcher.post('/staff/v1/settings/devices', data);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['settings', 'devices'] });
    },
  });
}

export function useDispatchDevice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, agentId, remarks }: { id: string; agentId: string; remarks?: string }) => {
      return fetcher.post(`/staff/v1/settings/devices/${id}/dispatch`, { agentId, remarks });
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['settings', 'devices'] });
      qc.invalidateQueries({ queryKey: ['settings', 'device-logs'] });
    },
  });
}

export function useReturnDevice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      return fetcher.post(`/staff/v1/settings/devices/${id}/return`, {});
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['settings', 'devices'] });
      qc.invalidateQueries({ queryKey: ['settings', 'device-logs'] });
    },
  });
}

export function useDeviceLogs(filters?: any) {
  return useQuery({
    queryKey: ['settings', 'device-logs', filters],
    queryFn: async () => {
      const params = filters ? '?' + new URLSearchParams(filters as Record<string, string>).toString() : '';
      return fetcher.get<any[]>(`/staff/v1/settings/device-logs${params}`);
    },
  });
}
